module.exports = __webpack_public_path__ + "img/news_page_info_solidarity.1bdc4168.png";